export const visaText = {
    study: {
        text: "We offer comprehensive study visa counselling services, coupled with student placement into some the most respectable universities in Europe, Asia, and America.",
        uri: "/visa-programs"
    },
    work: {
        text: "We offer comprehensive study visa counselling for skilled job seeker, who wish to work in Europe, Middle East, Asia and America.",
        uri: "/visa-programs"
    },
    tourist: {
        text: "We facilitate and aid in tourist visa applications to some of the most compelling countries with the most attractive touristics sites.",
        uri: "/visa-programs"
    },
    residence: {
        text: "Persons who wish to immigrate to foreighn countries such as Australia, Canada etc are welcome to make it a dream come true at UEST. We assess the visa application and assist in compilation",
        uri: "/visa-programs"
    },
    commercial: {
        text: "Aspiring businessmen and women who wish to travel to China, Singapore, Malaysia, Dubaii etc for business trips are welcome to trust UEST with helping them in their visa applications",
        uri: "/visa-programs"
    }

}